export const getRarityColor = (rarity) => {
  switch(rarity.toLowerCase()) {
    case 'common': return '#9e9e9e';
    case 'uncommon': return '#4caf50';
    case 'rare': return '#2196f3';
    case 'epic': return '#9c27b0';
    case 'legendary': return '#ff9800';
    default: return '#000';
  }
};

export function formatProductionTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${minutes}m`;
  }
} 